import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, Injector, NgModule} from '@angular/core';
import {CustomElementService} from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';
import { AvlAtLocationGmapComponent } from './avl-at-location-gmap.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { default as pjson } from '../../../../../package.json';

@NgModule({
  declarations: [
    AvlAtLocationGmapComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    ComponentSetupModule,
  ],
  exports: [
    AvlAtLocationGmapComponent
  ],
  providers: [
  ]
})

export class AvlAtLocationGmapModule {
  constructor(private injector: Injector, private customElementService: CustomElementService ) {

    customElementService.convertToCustomElement(AvlAtLocationGmapComponent, 'sc-avl-at-location-gmap', this.injector, pjson.version);
  }
}
